import {
  FIXED_COLUMNS,
  NO_TIMEPOINT_COLUMNS,
  SEARCHABLE_COLUMNS,
  TITLE_MAPPING,
  BB_HIDDEN_COLUMNS,
} from "../../../utils/tableConfigs/VAConstants";
import { isUnscheduledVisit } from "../../../utils/unscheduledVisitUtils/unscheduledVisitUtils";
import {
  getFormattedTitles,
  getCellWidth,
  getHiddenColumns,
  getCellRenderer,
  getSorter,
  createFilters,
  getDefaultFilteredValue,
  getCellProperties,
  getHeaderProperties,
  getFilterIcon,
  getSortIcon,
} from "../../../utils/tableConfigs/VAFunctions";
import {
  getFixedColumns,
  getSearchableColumns,
} from "../../../utils/tableConfigs/GlobalFunctions";
import { trials } from "../../../utils/trials";

export const getColumnConfig = (
  rows: Record<string, unknown>[],
  handleCellClick: (...args: unknown[]) => unknown,
  columnToHide: string,
  path: string,
  type: string,
  trialId: string,
  // False once the user hits "Clear all filters", so clearing really clears
  // instead of snapping the Study Status column back to its default.
  applyDefaultFilters = true,
) => {
  let headers = rows.length > 0 ? Object.keys(rows[0]) : [];

  if (trialId === trials.bridgebio.PROPEL) {
    headers = headers.filter((header) => !BB_HIDDEN_COLUMNS.has(header));
  }

  const columns = headers.map((header) => {
    const filters = createFilters(rows, header);
    const isUnscheduled = isUnscheduledVisit(header);

    return {
      title: () => getFormattedTitles(header, TITLE_MAPPING),
      dataIndex: header,
      key: header,
      sorter: getSorter(header),
      showSorterTooltip: false,
      onCell: (record: Record<string, unknown>) =>
        getCellProperties(record, header, handleCellClick, type),
      onHeaderCell: () => getHeaderProperties(header),
      render: (text: string | null | undefined, row: Record<string, unknown>) =>
        getCellRenderer(text, header, path, type, row),
      filterIcon: () => getFilterIcon(isUnscheduled),
      sortIcon: ({ sortOrder }: { sortOrder: "ascend" | "descend" | null }) =>
        getSortIcon(header, sortOrder),
      fixed: getFixedColumns(header, FIXED_COLUMNS),
      width: getCellWidth(header, trialId),
      align: NO_TIMEPOINT_COLUMNS.has(header) ? "left" : "center",
      filters: filters,
      defaultFilteredValue: applyDefaultFilters
        ? getDefaultFilteredValue(header, filters)
        : undefined,
      hidden: getHiddenColumns(header, columnToHide),
      onFilter: (value: unknown, record: Record<string, unknown>) => {
        if (
          value === "Not Required" ||
          value === null ||
          value === undefined ||
          value === "-"
        ) {
          return (
            record[header] === null ||
            record[header] === "-" ||
            record[`${header}_COMPLETION`] === "Not Required"
          );
        }
        if (NO_TIMEPOINT_COLUMNS.has(header)) return record[header] === value;
        if (typeof value === "string" && value.includes("/"))
          return record[header] === value;
        // Handle numeric values (like "1", "2") for US columns and others
        if (record[header] === value) return true;
        return record[`${header}_COMPLETION`] === value;
      },
      filterSearch: getSearchableColumns(header, SEARCHABLE_COLUMNS),
    };
  });

  return columns;
};
